//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'JobEnquiryInformation',

    props: {
        canModifyJob: {
            type: Boolean,
            default: false,
        },
        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    setup(props, { emit }) {
        const { $store } = useNuxtApp();

        const job = computed(() => $store.getters['jobs/single/getSingleJob']);

        const edit = () => {
            emit('open-draft', 2, '#description');
        };

        return {
            edit,
            job,
        };
    },
};
